import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import SuggestedFilterToken from 'Components/AdvisorApp/Header/ClientSearchBar/BetaSearchBar/SuggestedFilterToken';
import { useSearchBarState } from '../../SearchBarContext';
import SearchIconLoader from './SearchIconLoader';

const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  suggestedFilterToken: {
    marginLeft: theme.spacing(0.5),
  },
});

const StartAdornment = ({
  className,
  classes,
}) => {
  const { searchType } = useSearchBarState();
  return (
    <Box
      className={classNames(classes.root, className)}
      test={'global-search-start-adornment'}
    >
      <SearchIconLoader />
      {searchType ? (
        <SuggestedFilterToken
          className={classes.suggestedFilterToken}
          text={searchType}
          size={'sm'}
        />
      ) : null}
    </Box>
  );
};

StartAdornment.defaultProps = {
  className: '',
};

StartAdornment.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StartAdornment);
